import {Flex, Image} from '@chakra-ui/react';
import {FC} from 'react';

interface Props {
  grade: number;
}

export const ShowRating: FC<Props> = ({grade}) => {
  return (
    <Flex alignItems="center" mt={['0px', '12px']}>
      {Array.from({length: grade}, (_, i) => (
        <Image key={i} src="/star-active-icon.svg" alt="star" w="16px" mr="4px" />
      ))}
    </Flex>
  );
};
